import React from 'react'

const Testpage = () => {
  return (
    <div>Testpage
    
    <iframe
  src="http://localhost:3000/customer-register?base_url=http://localhost:8000&client_id=restaurant_001&primaryColor=orange&secondaryColor=%23FFF1F2&buttonColor=%23D32F2F&bgColor=%23FFF8F8&cardColor=%23FFFFFF&title=Register%20with%20Pizza%20Hub&subtitle=Join%20now%20for%20quick%20ordering&countryCode=%2B1"
  width="100%"
  height="760"
  style={{ border: "none", borderRadius: "16px" }}
></iframe>
    </div>
  )
}

export default Testpage